import { render, staticRenderFns } from "./Persetujuan.vue?vue&type=template&id=a5384c12&"
import script from "./Persetujuan.vue?vue&type=script&lang=js&"
export * from "./Persetujuan.vue?vue&type=script&lang=js&"
import style0 from "./Persetujuan.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports